export function toDecimalSeconds(s: number) {
  return parseFloat(s.toFixed(3));
}

export function toSeconds(ms: number) {
  return toDecimalSeconds(ms / 1000);
}

export function getVideoStartTimeOffsetSeconds(startTimeMs?: number | null) {
  return toSeconds(startTimeMs ?? 0);
}

export function getVideoTrimmedDurationSeconds(startTimeMs?: number | null, endTimeMs?: number | null) {
  if (typeof startTimeMs !== 'number' || typeof endTimeMs !== 'number') {
    return null;
  }
  return toSeconds(endTimeMs - startTimeMs);
}
